module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/purchase-8d1a54dc05d9583137a5c9d549e2b824.svg";